export default __webpack_public_path__ + "static/media/grafema_design-factory-kitchen-pictograms_07.5a6e846d.jpg";